import React from 'react';
import { message } from 'antd';
import { PhoneOutlined, WechatOutlined } from '@ant-design/icons';
import { BaseCardContent } from '../MessageType';

interface ContactCardViewProps {
  content: BaseCardContent;
}

export const ContactCardView: React.FC<ContactCardViewProps> = ({ content }) => {
  const wechatId = (content.wechatId as string) || '';
  const phone = (content.phone as string) || '';

  const copyText = async (text: string, label: string) => {
    try {
      await navigator.clipboard.writeText(text);
      message.success(`${label}已复制`);
    } catch {
      message.error('复制失败');
    }
  };

  return (
    <div className="message-card message-contact-card">
      <div className="message-card-title">联系方式</div>
      {phone && (
        <div className="message-contact-row">
          <PhoneOutlined style={{ color: '#1890ff', marginRight: 8 }} />
          <span>{phone}</span>
          <button
            type="button"
            className="message-contact-action"
            onClick={() => copyText(phone, '手机号')}
          >
            复制
          </button>
        </div>
      )}
      {wechatId && (
        <div className="message-contact-row">
          <WechatOutlined style={{ color: '#07c160', marginRight: 8 }} />
          <span>{wechatId}</span>
          <button
            type="button"
            className="message-contact-action"
            onClick={() => copyText(wechatId, '微信号')}
          >
            复制
          </button>
        </div>
      )}
    </div>
  );
};
